// extracted by mini-css-extract-plugin
var _1 = "AuthAboutManufacturer-moduleemailLink__tjHny";
export { _1 as "emailLink" }
